import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const navItems = [
  { label: "首页", href: "/" },
  { label: "网红黑料", href: "/category/influencer" },
  { label: "明星爆料", href: "/category/celebrity" },
  { label: "独家内幕", href: "/category/exclusive" },
  { label: "每日大赛", href: "/category/daily" },
  { label: "关于我们", href: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-14 md:h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-flashlight-fill text-background-50 text-sm"></i>
            </div>
            <span
              className={`text-lg md:text-xl font-bold tracking-tight transition-colors ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
              style={{ fontFamily: "var(--font-heading)" }}
            >
              爆料网
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    scrolled
                      ? isActive
                        ? "text-primary-500 bg-primary-50"
                        : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                      : isActive
                        ? "text-primary-400 bg-white/10"
                        : "text-background-200 hover:text-background-50 hover:bg-white/10"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换导航菜单"
          >
            <i
              className={`ri-menu-line text-xl ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="px-4 py-3 space-y-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`block px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? "text-primary-500 bg-primary-50"
                      : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
}